import React from "react";
import PropTypes from "prop-types";

const FormHiddenEntry = ({ placeholder = "", name = "", value = "", saveChanges = f => f }) => {
    return (
        <div>
            <input
                type="hidden"
                className="w3-input"
                name={name}
                placeholder={placeholder}
                value={value}
                onChange={evt => saveChanges(name, evt.target.value)}
            />
        </div>
    );
}

FormHiddenEntry.propTypes = {
    placeholder: PropTypes.string,
    name: PropTypes.string,
    saveChanges: PropTypes.func
};

export default FormHiddenEntry;
